import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Carts } from '@grandvisionhq/api-client';
import { useSelector, ApiConfigSelectors } from '@grandvisionhq/state';

const useReplicateCart = (refetch)=>{
    const apiConfig = useSelector(ApiConfigSelectors.getApiConfig);
    const replicateCart = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(orderId) {
            if (!apiConfig) {
                throw new Error('Need API configuration to replicate cart.');
            }
            return Carts.replicateCart(apiConfig.cartsUrl, {
                reference: {
                    typeId: 'order',
                    id: orderId
                }
            }).then((responseData)=>{
                refetch(responseData.id);
                return {
                    cartId: responseData.id
                };
            }).catch((error)=>{
                if (error instanceof Error) {
                    console.error(error);
                }
                throw new Error('Unknown error occurred while replicating cart, the current cart might be invalid');
            });
        });
        return function(orderId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        apiConfig,
        refetch
    ]);
    return React.useMemo(()=>[
            replicateCart
        ]
    , [
        replicateCart
    ]);
};

export { useReplicateCart };
//# sourceMappingURL=use-replicate-cart.js.map
